import React from 'react';
import { Route, Switch } from 'react-router';
import { ThemeProvider } from 'styled-components';

import { Layout } from './components/Layout';
import Home from './components/Home';
import Profile from './components/Profile';
import WithSideNav from './components/WithSideNav';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import ComponentShowroom from './components/ComponentShowroom';
import CheckIn from './components/CheckIn';
import { CheckInSummaryPage } from './components/CheckInSummary';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Admin from './components/admin/Admin';
import ClassView from './components/classes/ClassView';
import UserView from './components/user/UserView';
import EngagementPulse from './components/engagement-pulse/EngagementPulse';
import './custom.css'
//import './adam.css'
import theme from './theme';

const App = () => (
  <ThemeProvider theme={theme}>
    <Layout>
        <Switch>
          <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
          <AuthorizeRoute path='/admin' component={Admin} />
          <AuthorizeRoute exact path='/user/profile' component={Profile} />
          <Route path='/components' component={ComponentShowroom} />
          <Route path='/pulse/:id?' component={EngagementPulse} />
          <AuthorizeRoute exact path='/check-ins/:id' component={CheckIn} />
          <AuthorizeRoute path='/check-ins/:checkInId/summary' component={CheckInSummaryPage} />
          <AuthorizeRoute path='/user' component={UserView} />
          <Route path='/'>
            <WithSideNav>
              <AuthorizeRoute exact path='/' component={Home} />
              <AuthorizeRoute path='/classes/:id' component={ClassView} />
              <AuthorizeRoute path='/users/:id' component={UserView} />
            </WithSideNav>
          </Route>
        </Switch>
      </Layout>
  </ThemeProvider>
);

export default App;